/**
 * Validates that the date is equal to or after the current date with hour precision
 * @param {string|Date} value - The date to validate
 * @returns {boolean} - True if the date is equal to or after the current date with hour precision
 */
const validate = (value) => {
  if (!value) return true; // Let required rule handle empty values

  const selectedDate = new Date(value);
  const now = new Date();

  // Reset minutes, seconds and milliseconds to compare only up to hours
  selectedDate.setMinutes(0, 0, 0);
  now.setMinutes(0, 0, 0);

  return selectedDate >= now;
};

export default {
  name: 'after_or_equal_now',
  validate,
  message: 'Data musi być równa lub późniejsza od obecnej z dokładnością do godzin',
  params: []
};
